import { Stack } from "@mui/material";
import { useMemo } from "react";

import { FormControlLabel, Radio, Typography } from "@/components/ui-v2";
import { AspectRatio } from "@/types";

import { getAspectRatioString } from "./aspect-ratio";

interface AspectRatioRadioItemProps {
  aspectRatio: AspectRatio;
  onChange: (aspectRatio: AspectRatio) => void;
}

export const AspectRatioRadioItem = (props: AspectRatioRadioItemProps) => {
  const { aspectRatio, onChange } = props;
  const { width, height } = aspectRatio;

  const { label, aspectRatioString } = useMemo(() => {
    return {
      label:
        width > height ? "Landscape" : height > width ? "Portrait" : "Square",
      aspectRatioString: getAspectRatioString(width, height),
    };
  }, [width, height]);

  return (
    <FormControlLabel
      key={aspectRatio.type}
      value={aspectRatio.type}
      control={<Radio onChange={() => onChange(aspectRatio)} />}
      sx={{
        marginLeft: "initial",
      }}
      label={
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="small" fontWeight="bold">
            {label}
          </Typography>
          <Typography variant="small">{aspectRatioString}</Typography>
        </Stack>
      }
      slotProps={{
        typography: {
          flex: 1,
        },
      }}
    />
  );
};
